import React, { useState } from "react";
import { Icon } from "@iconify-icon/react";
import WorkHistory from "./WorkHistory";
import AddWorkHistory from "./AddEditWorkHistory";

interface ViewWorkHistoryProps {
  user: any;
}

const ViewWorkHistory = (props: ViewWorkHistoryProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const [addWorkOpen, setAddWorkOpen] = useState(false);

  const tabs = [{ id: 0, label: "Work History" }];

  const modernStyles = {
    borderRadius: "6px",
    fieldHeight: "35px",
    focusShadow: "0 0 0 2px rgba(0, 120, 212, 0.2)",
    hoverBorderColor: "hsl(var(--primary))",
    activeBorderColor: "hsl(var(--primary))",
    labelColor: "hsl(var(--foreground))",
    placeholderColor: "hsl(var(--foreground))",
    spacing: "16px",
    descriptionColor: "hsl(var(--foreground))",
    backgroundColor: "hsl(var(--primary))",
    hoveredBackgroundColor: "hsl(var(--primary))",
  };

  const tabContent = [
    <div key={0} className="content">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2
          className="contentTitle"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Icon className="cardIcon" icon="mdi:briefcase" />
          Work History
        </h2>
        <button
          type="button"
          onClick={() => setAddWorkOpen(true)}
          className="btn-primary"
          style={{
            minWidth: "80px",
            borderRadius: modernStyles.borderRadius,
            backgroundColor: modernStyles.backgroundColor,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <Icon icon="mdi:plus" />
          <span>Add Work Experience</span>
        </button>
      </div>
      <div className="contentCard">
        <WorkHistory user={props.user} />
      </div>
    </div>,
  ];

  return (
    <div>
      <h1 className="title">Work History</h1>

      <div className="tabContainer">
        <nav className="tabNav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tabButton ${
                activeTab === tab.id ? "activeTab" : "inactiveTab"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="contentContainer">{tabContent[activeTab]}</div>
      <AddWorkHistory
        isOpen={addWorkOpen}
        onDismiss={() => setAddWorkOpen(false)}
      />
    </div>
  );
};

export default ViewWorkHistory;
